import httpclient from "libs/Axios";
import httpClientWithoutAbort from "libs/Axios/httpClientWithoutAbort";
export const apiFileUpload = async (
  formData: FormData,
  action: 'update' | 'upload',
  fileUrl?: string,
  JsonString?: string,
  multi?: boolean,
  updateFiles?: boolean,
  uploadWithoutCancel?: boolean
) => {
  const __req = JsonString ? JSON.parse(JsonString) : undefined;
  let response:any = {};
  if(uploadWithoutCancel) {
    response = await httpClientWithoutAbort().post(
      `/data/${action}/${multi ? (!updateFiles ? 'files' : 'tempfiles') : 'photo'}${fileUrl ? `?file_url=${fileUrl}` : ''}${__req ? `?database=${__req.DATABASE}&branch_id=${__req.BRANCH_ID}&saved_id=${__req.SAVED_ID}&role=${__req.ROLE}` : ''}`,
      formData, {
        headers: {
          'Custom-Header': 'multipart/form-data', // Add custom headers for this specific request
        },
      }
    );
  } else {
    response = await httpclient().post(
      `/data/${action}/${multi ? (!updateFiles ? 'files' : 'tempfiles') : 'photo'}${fileUrl ? `?file_url=${fileUrl}` : ''}${__req ? `?database=${__req.DATABASE}&branch_id=${__req.BRANCH_ID}&saved_id=${__req.SAVED_ID}&role=${__req.ROLE}` : ''}`,
      formData, {
        headers: {
          'Custom-Header': 'multipart/form-data', // Add custom headers for this specific request
        },
      }
    );
  }
  const data = JSON.stringify(response?.data);
  return data;
};